export const internalKey = '_internal';

export enum SurfaceSource {
    Composer = 'composer',
    Figma = 'figma',
}

export enum SurfaceTabKey {
    Setup = 'setup',
    Template = 'template',
    Messages = 'messages',
    Funnel = 'funnel',
    Review = 'review',
}
